var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.026 20.57v-3.213a3.214 3.214 0 0 0-3.214-3.214H5.615A3.214 3.214 0 0 0 2.4 17.356v3.215m19.2 0v-3.214a3.214 3.214 0 0 0-3.215-3.214M15.406 4.06a3.21 3.21 0 0 1 1.301 2.582 3.21 3.21 0 0 1-1.3 2.583m-2.913-2.583a3.214 3.214 0 1 1-6.428 0 3.214 3.214 0 0 1 6.428 0Z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.baf6b0722967d6e1e0a45788f4657fdc.svg";
export { ForwardRef as ReactComponent };